import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {
  transform(value: any, args?: string) {
    if (!isNaN(value) && value) {
      const newValue = value + '',
        spaces: Array<number> = [3, 6, 8, 10];
      let newStr = '';
      for (let i = 0; i < newValue.length; i++) {
        if (spaces.includes(i)) {
          newStr += ' ' + newValue.charAt(i);
        } else {
          newStr += newValue.charAt(i);
        }
      }
      return newStr;
    }
    return value;
  }
}
